/**
 * @param arrA - first array
 * @param arrB - second array
 * @returns array of elements that are in both arrays
 */
export const intersection = <T extends string | number | symbol>(
  arrA: readonly T[],
  arrB: readonly T[]
) => {
  const [setA, setB] = [new Set(arrA), new Set(arrB)];

  return Array.from(setA).filter(e => setB.has(e));
};
